import {useSalesMarketingApi} from "./useSalesMarketingApi";
import qs from "qs";
import {Detection, DetectionFilters} from "../page/detection/constants/DetectionInterfaces";

export const useDetectionActions = () => {
    const {GET, POST, PUT} = useSalesMarketingApi();

    async function getDetections(filters: DetectionFilters,subscriptionId:string):Promise<{totalElements : number, content: Detection[]}>{
        let params={
            tenantId: filters.legalEntity ? filters.legalEntity : undefined,
            dealerId: filters.dealer ? filters.dealer : undefined,
            detectionDate: filters.detectionDate ? filters.detectionDate : undefined,
            search: filters.search ? filters.search : undefined,
            offset: filters.offset,
            limit: filters.limit,
            sort: filters.sort ? filters.sort : undefined,
            order: filters.order ? filters.order : undefined,
            subscriptionId
        }
        let data = await GET("sm/detection/", true, {
            params: params,
            paramsSerializer: (params: any) => qs.stringify(params, {arrayFormat: 'repeat', skipNulls: true})
        });
        return {
            totalElements: data?.result?.totalElements,
            content: data?.result?.content
        };
    }

    async function getDetectionById(id: string): Promise<Detection>{
        let data = await GET("sm/detection/" + id, true);
        return data?.result;
    }

    return{
        getDetections,
        getDetectionById
    }

}